import { useMemo, useState } from 'react'

export const initialRowSelection = {}
const useTableRowSelection = rows => {
  const [rowSelection, setRowSelection] = useState(initialRowSelection)
  const rowIds = useMemo(() => {
    return rows?.map(({ id }) => id)
  }, [rows])

  const rowSelectionList = useMemo(() => {
    return Object.keys(rowSelection)
  }, [rowSelection])

  return useMemo(
    () => ({
      rowIds,
      rowSelection,
      rowSelectionList,
      setRowSelection
    }),
    [rowIds, rowSelection, rowSelectionList]
  )
}

export default useTableRowSelection
